import { Mail } from "lucide-react";

import { useDialog } from "@/contexts/DialogContext";

import { Button } from "../../core/Button";

export const MailingListsButton = () => {
  const Dialog = useDialog();

  return (
    <Button
      size="sm"
      variant="ghost"
      onPress={() =>
        Dialog.dispatch({
          action: "OPEN_DIALOG",
          dialog: { id: "MAILING_LISTS" },
        })
      }
    >
      <Mail aria-hidden="true" size={18} />
      <p>Mailing Lists</p>
    </Button>
  );
};
